import React, { useEffect, useRef, useState } from 'react';
import Player from '../Player/Player';
import Channels from './Channels';
import EpgListing from './EpgListing';

import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { media } from '../../other/breakpoints';

import { setPlayingChannel } from '../../actions/playingChannel';
import { setGroupList } from '../../actions/set-Group';
import { setPlaylist } from '../../actions/set-Playlist';

import { resetMemory, setGroup } from '../../other/last-opened-mode';

import { useHistory, useParams } from 'react-router-dom';
import { loadGroup, loadPlaylist } from '../../other/load-playlist';

import { useLang } from '../../language/LanguageProvider.jsx';
import Popup from '../Popup/Popup';

import DB from '../../other/local-db';

const Main = styled.div`
  padding: calc(4rem + 3vh) 1vw 3vh 1vw;
  background-color: var(--first-color);
  min-height: calc(100vh - 4rem);
  z-index: 1;
  transition: filter 0.5s ease;
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.mobile} {
    padding: 6rem 1rem 3rem 1rem;
    min-height: auto;
    height: auto;
    max-width: 100vw;
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-x: hidden;

  ${media.mobile} {
    gap: 2.5rem;
  }

  @media (min-width: 1001px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 1.5rem;
  }
`;

const PlayerEpgWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
  flex-shrink: 0;

  ${media.mobile} {
    gap: 2rem;
  }

  @media (min-width: 1001px) {
    flex: 1 1 60%;
    min-width: 0;
  }
`;

const ChannelsWrapper = styled.div`
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;

  ${media.mobile} {
    overflow: visible;
  }

  @media (min-width: 1001px) {
    flex: 1 1 40%;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
  }
`;

const ChannelTitle = styled.h5`
  color: white;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;

  ${media.mobile} {
    margin-bottom: 1rem;
  }
`;

const MainLive = () => {
  const [blurBackground, setBlurBackground] = useState();
  const { t } = useLang();

  const playingChannel = useSelector((state) => state.playingCh);
  const playlist = useSelector((state) => state.playlist);
  const dispatch = useDispatch();
  const history = useHistory();

  const { category } = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const scrollPositionRef = useRef(0);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setRefreshKey((prev) => prev + 1);
    };

    const handleOrientationChange = () => {
      setTimeout(() => {
        setRefreshKey((prev) => prev + 1);
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    const fun = async () => {
      const noCategory =
        category === undefined || (isNaN(category) && category !== 'all');
      setBlurBackground(
        noCategory || history.location.pathname.includes('menu')
          ? { filter: 'blur(.5rem)', pointerEvents: 'none' }
          : {}
      );

      if (category !== undefined && category !== 0) {
        let chs = await loadPlaylist('live', category);
        chs = chs || [];
        if (category === 'fav')
          chs = chs.filter((x) => DB.findOne('live', x.stream_id, true));
        dispatch(setPlaylist(chs));
        if (chs.length === 0) {
          setShowPopup(1);
        } else {
          // Verificar se o canal atual ainda está na lista
          const currentChannelInList =
            playingChannel &&
            chs.some((ch) => ch.stream_id === playingChannel.stream_id);

          if (!currentChannelInList) {
            // Auto-selecionar o primeiro canal com "HD" completo no nome
            const hdChannel = chs.find((ch) => {
              if (!ch.name) return false;
              // Procura apenas por "HD" completo (não FHD nem FULL HD)
              return /\bHD\b/i.test(ch.name);
            });
            if (hdChannel) {
              dispatch(setPlayingChannel(hdChannel));
            } else if (chs.length > 0) {
              // Se não encontrar HD, seleciona o primeiro canal
              dispatch(setPlayingChannel(chs[0]));
            }
          }
        }
      } else if (resetMemory('live')) {
        await loadGroup('live').then((gps) => {
          if (!gps || gps.length === 0) {
            history.replace('/');
            return;
          }
          // Inserir 'Todos os Canais' no topo e manter 'Only favorites' em seguida
          gps.unshift({ category_name: 'Todos os Canais', category_id: 'all' });
          gps.splice(1, 0, {
            category_name: 'Favoritos',
            category_id: 'fav',
          });
          setGroup('all');
          dispatch(setGroupList(gps));
          history.replace('/live/category/all/');
        });
      } else {
        // Sempre redirecionar para 'all' quando não houver categoria definida
        history.replace('/live/category/all/');
      }
    };
    fun();
  }, [dispatch, category]);

  useEffect(() => {
    if (history.location) {
      const noCategory =
        category === undefined || (isNaN(category) && category !== 'all');
      setBlurBackground(
        noCategory || history.location.pathname.includes('menu')
          ? { filter: 'blur(.5rem)', pointerEvents: 'none' }
          : {}
      );
    }
  }, [history.location.pathname, category]);

  // Proteção contra scroll automático quando o canal muda
  useEffect(() => {
    if (playingChannel) {
      // Salvar posição de scroll atual
      scrollPositionRef.current =
        window.pageYOffset || document.documentElement.scrollTop || 0;

      // Restaurar posição após possível scroll automático
      const restoreScroll = () => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop || 0;
        if (Math.abs(currentScroll - scrollPositionRef.current) > 10) {
          window.scrollTo({
            top: scrollPositionRef.current,
            behavior: 'auto',
          });
        }
      };

      // Tentar restaurar imediatamente e após um pequeno delay
      requestAnimationFrame(restoreScroll);
      setTimeout(restoreScroll, 50);
      setTimeout(restoreScroll, 150);
    }
  }, [playingChannel]);

  return (
    <div>
      <Main style={blurBackground}>
        <MainContainer>
          <PlayerEpgWrapper>
            <ChannelTitle>
              {playingChannel
                ? playingChannel.name
                : t('live.noChannelSelected')}
            </ChannelTitle>
            <Player />
            <EpgListing
              Epg={playingChannel ? playingChannel.epg_channel_id : null}
              Shift={playingChannel ? playingChannel.shift : null}
            />
          </PlayerEpgWrapper>
          <ChannelsWrapper>
            <Channels playlist={playlist} />
          </ChannelsWrapper>
        </MainContainer>
      </Main>
      {showPopup && (
        <Popup
          title={t('live.noStreamInCategory')}
          icon={'fas fa-times'}
          onclick={() => {
            setBlurBackground({});
            setShowPopup(0);
            history.replace('/live/category/');
          }}
        />
      )}
      {/*window.gSTB && (<Tips/>)*/}
    </div>
  );
};

export default MainLive;
